import {toChat} from '@/common-pages/game-navigate';
import React, {useEffect, useState} from 'react';
import chatSvg from '@assets/icons/chat.svg';
import {imManager} from '@/common-pages/im/im.state';

const HomeChat = () => {
  const [unread, setunRead] = useState(imManager.getState().unread);
  useEffect(() => {
    const sub = imManager.unread.subscribe(val => {
      setunRead(val);
    });
    return () => {
      sub.unsubscribe();
    };
  }, []);
  return (
    <div
      className="rounded-full relative border-2 w-[3.25rem] h-[3.25rem] border-white flex items-center justify-center flex-col bg-gradient-to-b from-[rgba(0,181,18,1)] to-[rgba(0,171,171,1)] ]"
      onClick={toChat}>
      <img
        className="w-5 h-5 "
        // @ts-ignore
        src={chatSvg}
        alt=""
      />
      {unread > 0 && (
        <div className="bg-[#e40000] text-white text-[0.625rem] font-bold rounded-3xl flex items-center justify-center h-5 min-w-5 px-1 box-border absolute -top-1.5 -right-1.5">
          {unread > 99 ? '99+' : unread}
        </div>
      )}

      <div className="text-white font-bold text-xs">Chat</div>
    </div>
  );
};

export default HomeChat;
